/*
 *  Allows navigation of a form using arrow, tab, and enter keys
 *  Requires passing the keydown event, along with the number of rows and columns in the form
 *  @param {Object} e
 *  @param {String} id
 *  @param {Number} rows
 *  @param {Number} cols
 *  @param {Number} offset
 *  @return {Number} newFocus
 */
export function navigateLines (e, id, rows, cols, offset = 0, isLastCell = false, isReliefCell = false) {
  let newFocus
  switch (e.keyCode) {
    case 40:                                                                 // Down arrow
      newFocus = id + 1
      break
    case 38:                                                                 // Up arrow
      newFocus = id - 1
      break
    case 37:                                                                 // Left arrow
      newFocus = id - rows
      break
    case 39:                                                                 // Right arrow
    case 9:                                                                  // Tab
    case 13:                                                                 // Enter
      if (e.keyCode === 13 && isReliefCell) {
        newFocus = id + 1
      } else if (isLastCell) {
        newFocus = (id - ((rows * (cols - 1)) - rows) + 1)
      } else {
        newFocus = id + rows
      }
  }
  if (!newFocus || newFocus > ((rows * cols) + offset) || newFocus < 0) return id
  return newFocus
}

export function navigateHeader (e, id, rows, cols, offset = 0) {
  let newFocus
  switch (e.keyCode) {
    case 40:                                                                 // Down arrow
    case 13:                                                                 // Enter
      newFocus = id + 1
      break
    case 38:                                                                 // Up arrow
      newFocus = id - 1
      break
    case 37:                                                                 // Left arrow
      newFocus = id - rows
      break
    case 39:                                                                 // Right arrow
    case 9:                                                                  // Tab
      newFocus = id + rows
      break
  }
  if (!newFocus || newFocus > ((rows * cols) + offset) || newFocus < 0) return id
  return newFocus
}



// WEBPACK FOOTER //
// ./src/utils/helpers/NavigateForm.js